import React from 'react';
/**
 * OneTrustScript component allows consumer to include OneTrust vendor script in the application.
 * - OneTrust dashboard - https://sony.my.onetrust.com/cookies/websites
 *
 * The component injects two script tags -
 * 1. OneTrust script for auto-blocking known cookies, pixels and web beacons
 * 2. OneTrust banner script required to display OneTrust notice
 *
 * ## Usage -
 *
 * ```jsx
 * <OneTrustScript>
 * ```
 *
 * ## Note - don't make any changes to the script except below callback functions -
 * 1. window.OneTrust.launchConsentAccepted
 * 2. window.OneTrust.launchConsentDeclined
 *
 * @returns OneTrust vendor scripts
 */

var OneTrustScript = function OneTrustScript() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("script", {
    type: "text/javascript",
    src: "https://cdn.cookielaw.org/consent/0194a27f-57a3-7617-afa7-86ca2a2123a3/OtAutoBlock.js"
  }), /*#__PURE__*/React.createElement("script", {
    type: "text/javascript",
    src: "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js",
    "data-domain-script": "0194a27f-57a3-7617-afa7-86ca2a2123a3"
  }));
};

export default OneTrustScript;